<template>
  <candidate-profile/>
</template>

<script>
import CandidateProfile from '../components/CandidateProfile/index'
export default {
  components: {CandidateProfile},

}
</script>

<style>

</style>
